import axios from "axios";
import ElementUI from "element-ui";
import { apiRoot, getHeader } from "./ajax";

const request = (method, path, options = {}) => {
  const { data, params, shown = 1 } = options;
  return axios({
    method,
    headers: getHeader(),
    url: apiRoot(path, "PaymentAPI"),
    data,
    params,
  })
    .then((res) => res.data)
    .catch((err) => {
      const message =
        err.response && err.response.data
          ? err.response.data.message || err.response.data.errorDesc
          : "";
      if (shown) {
        ElementUI.Message({
          message: message || "会员服务异常，请稍后重试",
          type: "error",
        });
      }
      throw err;
    });
};

export const queryMemberPlans = () => {
  return request("GET", "/api/member/plans");
};

export const createWechatNativeOrder = (params) => {
  return request("POST", "/api/member/orders/wechat/native", {
    data: params,
  });
};

export const queryMemberOrder = (orderId) => {
  return request("GET", `/api/member/orders/${orderId}`, {
    shown: 0,
  });
};

export const queryMemberOrders = (userId, params = {}) => {
  return request("GET", `/api/member/users/${userId}/orders`, {
    params,
    shown: 0,
  });
};

export const createMemberUserOrder = (userId) => {
  const normalizedUserId = String(userId);
  return request("POST", "/api/member/users/trial", {
    data: {
      userId: normalizedUserId,
    },
  });
};

export const queryUserMembership = (userId, shown = 0) => {
  return request("GET", `/api/member/users/${userId}/membership`, {
    shown,
  });
};

export const redeemMemberCard = (params) => {
  return request("POST", "/api/member/cards/redeem", {
    data: params,
    shown: 0,
  });
};
